<script lang="ts" setup>
import { useEmConsoCompareStore } from "@modules/energy-manager/stores/em-conso-compare.store"
import { useVModel } from "@vueuse/core"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useLangHelpers } from "@modules/energy-manager/composables/useLangHelpers"

type Props = {
    variable: string
}

const emit = defineEmits(["update:variable"])

const props = withDefaults(defineProps<Props>(), {
    variable: "",
})

const emConsoCompareStore = useEmConsoCompareStore()

const variable = useVModel(props, "variable", emit, {
    eventName: "update:variable",
})

const { buildWarningVariable } = useLangHelpers()
/**
 * Indique si la variable sélectionné a une limitation de fréquence
 * car trop de sources pour l'analyse
 */
const hasFreqLimitByDisplayDataConfig = computed(() => {
    return emConsoCompareStore.getDisplayDataConfig?.messageLimit
})

const { t } = useI18n({
    useScope: "local",
    messages: {
        fr: {
            title: "Variable limitée en raison du volume important de sources",
            content: ({ named }: { named: (key: string) => string }) => {
                return named("sentence")
            },
        },
    },
})
</script>

<template>
    <BaseInputWrapper
        input-id="variable"
        class="dashboard-card-compare-variable"
        unfloat
    >
        <template #header>
            <div class="flex items-center">
                <BaseIcon icon="fal fa-circle-1" color="var(--p-primary-700)" />
                <!-- Message par rapport à la fréquence limitée-->
                <BaseTooltipMessage
                    @click.prevent.stop
                    v-if="hasFreqLimitByDisplayDataConfig"
                    severity="warn"
                    class="ml-2"
                    :title="t('title')"
                    :content="
                        t('content', {
                            sentence: buildWarningVariable(
                                emConsoCompareStore.getDisplayDataConfig
                                    ?.config_periods ?? {},
                                emConsoCompareStore.getSourcesCount
                            ),
                        })
                    "
                />
            </div>
        </template>
        <SelectVariable v-model:variable="variable" input-id="variable" />
    </BaseInputWrapper>
</template>
